import { render } from "./RuiPerson.vue?vue&type=template&id=b6034296"
const script = {}
script.render = render

export default script